import { FC, ReactNode, useState } from "react";
import { Flex, Collapse, Heading, Text } from "@chakra-ui/react";
import { Anchor } from "~/components";
import { sharedProps } from "~/constants";
import { Minus, Plus } from "~/icons";

interface Props {
  heading: string;
  id?: string;
  isLast?: boolean;
  text: string | ReactNode;
  maxW?: string;
}

export const CollapsibleText: FC<Props> = ({
  heading,
  id,
  isLast,
  text,
  maxW = "59.125rem",
}) => {
  const [show, setShow] = useState(false);
  const handleToggle = () => setShow(!show);
  const borderBottom = isLast ? "none" : "1px solid";
  const Icon = show ? Minus : Plus;

  return (
    <Flex
      borderBottom={borderBottom}
      borderBottomColor="fg-accent"
      direction="column"
      id={id}
      py={4}
      textAlign="left"
      maxW={maxW}
      w="100%"
    >
      <Anchor id={id || ""}>
        <Flex align="center" cursor="pointer" onClick={handleToggle}>
          <Icon color="fg-accent-light" mr={3} w="1.2rem" h="1.2rem" />
          <Heading fontSize={sharedProps.formLabel.default.fontSize}>
            {heading}
          </Heading>
        </Flex>
        <Collapse in={show}>
          <Text ml={8} my={4}>
            {text}
          </Text>
        </Collapse>
      </Anchor>
    </Flex>
  );
};
